import { Box } from "@mui/material";

import { Option } from "api/common/types/common.types";
import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const LabSelectSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    ccLabs: [] as Option[],
  },
  render: function Render({ form, ccLabs }) {
    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField name="ccLab">
          {(field) => (
            <field.AutocompleteSelect options={ccLabs} label="Lab" required />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default LabSelectSection;
